import React from 'react';

import CloudsBackground from '../BackgroundCloud';
import './style.scss';

const PublicLayout = ({ children }) => {
  return (
    <div className="publicLayout-container">
      <CloudsBackground />
      {children}
    </div>
  );
};

export default PublicLayout;
